import { css } from '@linaria/core';
import { LegacyTeaserLabel } from '../primitives';
import { Label } from '../../primitives/teaser/teaserPrimitiveStyles';
export const Root = {
    base: css `
		position: relative;
		z-index: 0;

		float: left;

		width: 100%;
		height: 100%;

		background: transparent;

		> div {
			backface-visibility: hidden;
		}
	`,
    textPosition: {
        onImage: css `
			z-index: 0;
		`,
        besideImage: css `
			width: 30%;
		`,
        belowImage: null,
        none: null,
    },
};
export const EpisodeNumber = {
    base: css `
		margin-bottom: 10px;
		/* stylelint-disable-next-line -- ToDo: replace by global color CSS variable when in design system available (hex & rgb) */
		color: #fff;
	`,
};
export const CornerLogo = {
    base: css `
		float: right;
		display: flex;

		box-sizing: border-box;
		width: 60px;
		height: 60px;
		padding: 10px;

		background: rgb(var(--global-background));
		> svg {
			width: 100%;
			path {
				fill: rgb(var(--global-text));
			}
		}
	`,
};
export const Additive = {
    base: css `
		pointer-events: none;

		position: absolute;
		z-index: 2;
		top: 0;
		left: 0;

		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 5px;
		> * {
			pointer-events: all;
		}
		.${LegacyTeaserLabel.base}, .${Label.base} {
			vertical-align: top;
		}
	`,
    isLive: css `
		.${LegacyTeaserLabel.base}, .${Label.base} {
			background: rgb(var(--brand-live));
		}
	`,
};
